import { HttpInterceptorFn } from '@angular/common/http';
import { BusyService } from '../_services/busy.service';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {

  let busyService = inject(BusyService);
  const useInline = typeof window !== 'undefined' && window.location?.pathname?.includes('/ui-new');
  const mode: 'fullscreen' | 'inline' = useInline ? 'inline' : 'fullscreen';
  busyService.busy(mode);

  return next(req).pipe(
    finalize(() => {
      busyService.idle(mode);
    })
  );
};
